"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraRahastoTag = void 0;
const react_1 = __importDefault(require("react"));
require("../styles/eura-rahasto-tag.css");
const EuraRahastoTag = (props) => {
    var _a;
    const rahastoPart = props.rahasto.toString().replace('+', '');
    const eakrTyyppiStripped = (_a = props.eakrTyyppi) === null || _a === void 0 ? void 0 : _a.replace('JTF ', '').replace('FRO ', '');
    const eakrTyyppiPart = props.eakrTyyppi && props.eakrTyyppi !== 'YLEINEN' ? eakrTyyppiStripped : undefined;
    const tagClassName = eakrTyyppiPart ? `${rahastoPart}_${eakrTyyppiPart}` : rahastoPart;
    return (react_1.default.createElement("div", { "data-testid": props.dataTestId, className: `rahasto-tag rahasto-tag__${tagClassName}` },
        react_1.default.createElement("span", { className: 'top' }, props.rahasto),
        eakrTyyppiPart && react_1.default.createElement("span", { className: 'bottom' }, eakrTyyppiStripped)));
};
exports.EuraRahastoTag = EuraRahastoTag;
